module.exports = __webpack_public_path__ + "img/logo_grillmanero.b8d73f5b.jpg";